import React, { useCallback, useMemo, useState } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import styled from 'styled-components'
import CalendatDay from '../../icons/IconLib/CalendarIcon'
import EditIcon from '../../icons/IconLib/PencilIcon'
import InvoiceIcon from '../../icons/IconLib/InvoiceIcon'
import LogIcon from '../../icons/IconLib/TimelineIcon'
import MoonIcon from '../../icons/IconLib/MoonIcon'
import PackageIcon from '../../icons/IconLib/PackageBoxIcon'
import PrintIcon from '../../icons/IconLib/PrintIcon'
import SpeedIcon from '../../icons/IconLib/TruckIcon'
import SunIcon from '../../icons/IconLib/SunIcon'
import UserIcon from '../../icons/IconLib/UserIcon'
import VerticalDots from '../../icons/IconLib/MoreVerticalIcon'
import CirclePercentElement from '../../particles/CirclePercentElement'
import { convertToDate } from '../../../modules/convertDateString'
import DetailesItem from '../../../main/second/mainbar/likutExpress/monitoring/DetailesItem'
import TitlesList from '../../titlesRowItem/TitlesList'
import { statusConverter } from '../../artcoded/statusAzmanot'
import DropdownByIcon from '../../../main/second/mainbar/azmanotRehesh/Layouts/DropdownByIcon'
import { Link } from 'react-router-dom'
import { LINKS } from '../../../Routs/config'

export const MainItemWrapper = styled.div`
    background: rgba(41,127,118,0.31);
    width: 100%;
    /* min-height: 5em; */
    border-radius: 30px;
    -webkit-box-shadow: 0px 1px 2px 2px rgba(161,161,161,0.1); 
    box-shadow: 0px 1px 2px 2px rgba(161,161,161,0.1);
    display: flex;
    flex-flow: column;
    gap: 0.5em;
    
`

export const HeadContentWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 5em;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    justify-content: flex-start;
    /* background: #fff; */
    border-radius: 30px;
    background: ${props => props.$color ? `#${props.$color}` : '#fff'};
    color: #75759e;
    padding: 0.5em 2.5em;
    gap: 0.2em;
`
const HeadContentElement = styled.div`
    /* width: 100%; */
    display: flex;
    justify-content: flex-end;
    gap: 0.5em;
    font-size: ${props => props.$primal ? '1.1em' : props.$date ? '0.9em' : '1em'};
    /* color: #75759e; */
`
export const DetailesBody = styled.div`
    padding: 0.5em;
    display: ${props => props.$isActive ? 'flex' : 'none'};
`

const IconWrapper = styled.div`
    color: ${props => props.$primal ? 'tomato' : ''};

`
export const QtyBoxWrapper = styled.div`
    position: absolute;
    left: 1em;
    top: .75em;
    display: flex;
    justify-content: center;
    align-items: center;

    `
    const OverlayButton = styled.div`
        position: absolute;
        display: none;
        ${QtyBoxWrapper}:hover & {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 80%;
            height: 80%;
            background: #fff;
            border-radius: 30px;
            color: #297F76;
            font-size: 1.2em;
            cursor: pointer;
        }
    `
export const SideBlock = styled.div`
    position: absolute;
    height: 2em;
    width: 4em;
    background: ${props => props.$primal ? props.$primal : '#d3ffce'};
    transform: rotate(-90deg);
    top: 1.35em;
    right: -1.2em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    font-size: 1em;
    font-weight: 600;
    color: #75759e;
    box-shadow: -3px -3px 5px #cecece;
`
const KwucaBlock = styled.div`
    padding: 0.2em 0.4em;
    background: ${props => props.$primal ? '#faceff' : '#d3ffce'};
    border-radius: 10px;
    transform: translateY(-0.2em);
`
export const SelectWorkerButton = styled.div`
    border-radius: 5px;
    color: #ffff;
    padding: 0.1em 0.5em;
    display: flex;
    align-items: center;
    background: #297f76;
    transform: translateY(-2px);
    font-size: 0.7em;
    cursor: pointer;
`
 const OrderGetheringItemWithDetailes = ({
    Customer_Name, OrderID, index, Delivery_Date, detailes, Type, Products, 
    actionFunc, item, teudot, selectProductForRemark, selectTeudaFunc=undefined,
    workersList, WorkerID, GroupDesc, ProductsWithSupplyPacks,
    selectIconForPalletType, Status, GroupID, Delivery_Code,  CustomerID,
    Packs, openEditRemarkLikut, Color, handlePalletDetailsModal, isWeightCalculation, handleOpenOrderStatusLogModal, handleOpenPalletLogModal,
    handleOpenWorkerHistoryModal
}) => {
    const [showDetailes, setShowDetailes] = useState(false)
    const checkForResons = useMemo(() => detailes?.some(e => e.ChangeReason !== 0) ,[detailes]) 
    const {status, color} = useMemo(() => {return statusConverter(Status)}, [Status]) 
    const currentDate = useMemo(() => convertToDate(Delivery_Date), [Delivery_Date])
     const handleOpenPalletLogfunc = () => {
        if(!handleOpenPalletLogModal) return
        handleOpenPalletLogModal(teudot[0])
     }
    const detailesRenderQuery = useCallback((item) => {
        return item.ChangeReason !== 0 || !!item.IsProblemRow
    }, [])
    let showAcpaca = Type === 1 ? <InvoiceIcon /> : <SpeedIcon color={'tomato'} />

    const handleClick = (e) => {
        e.stopPropagation()
        if(Status !== 9) return
        const obj = teudot.at(-1)
        // console.log(obj)
        actionFunc(obj.Delivery_Num | obj.deliveryNum, obj.Delivery_Sub | obj.deliverySub)
    }
    const handleDropDown = (e) => {
        // console.log(`#${Color}`)

        setShowDetailes(!showDetailes);
    }
    const handleOpenRemark = (e) => {
        e.stopPropagation()
        openEditRemarkLikut(item) 
    }
    const handleOpenSelectWorker = (e) => {
        e.stopPropagation()
        actionFunc(item) 
    }
    const hadlePalletDetailsByOrder = (e) => {
        if(!handlePalletDetailsModal) return
        e.stopPropagation()
        handlePalletDetailsModal(item)
    }

    const handleOpenMenu = e => {
        e.stopPropagation()
    }
    const linkToTeuda = (e) => {
        e.stopPropagation()
        console.log('123')
        if(!teudot[0]) return
        selectTeudaFunc(teudot[0])
    }
    const handleOpenOrderStatusLog = (e) => {
        e.stopPropagation()
        handleOpenOrderStatusLogModal(item)
    }
    const handleOpenWorkerHistory = (e) => {
        if(!handleOpenWorkerHistoryModal) return
        e.stopPropagation()
        handleOpenWorkerHistoryModal(item)
    }
    const sortable = useSortable({ id: OrderID?.toString() ?? `order-${index}` })
    const sortableStyle = {
        transform: CSS.Transform.toString(sortable.transform),
        transition: sortable.transition,
        opacity: sortable.isDragging ? 0.25 : 1,
    }

    return (
                    <MainItemWrapper
                        ref={sortable.setNodeRef}
                        style={sortableStyle}
                        {...sortable.attributes}
                        {...sortable.listeners}
                        onClick={handleDropDown}
                    >
                        <HeadContentWrapper
                            $color={Color?.trim()}
                        >
                            <SideBlock
                                $primal={color}
                                onClick={handleOpenOrderStatusLog}
                            >
                                {status}
                            </SideBlock>
                            <QtyBoxWrapper 
                                onClick={handleOpenMenu}
                            >   
                                {
                                    handlePalletDetailsModal &&
                                    <OverlayButton 
                                        onClick={hadlePalletDetailsByOrder}
                                    >
                                        <PackageIcon />
                                    </OverlayButton>
                                }
                                <CirclePercentElement
                                    content={
                                        Status === 9 ? 
                                        <DropdownByIcon
                                            icon={<VerticalDots />}
                                            
                                        >
                                        <WrapperMenu>
                                            <Link
                                                onClick={linkToTeuda}
                                                to={`${LINKS.teudot.teudotMishloah.createByID}${teudot?.[0]?.Delivery_Num}/${teudot?.[0]?.Delivery_Sub}`}
                                                target='_blank'
                                            >

                                                <IconWrapperMenu
                                                    onClick={linkToTeuda}
                                                >
                                                    <EditIcon />
                                                </IconWrapperMenu>
                                            </Link>
                                            <IconWrapperMenu
                                                onClick={handleClick}
                                            >
                                                <PrintIcon />
                                            </IconWrapperMenu>
                                            {
                                                handlePalletDetailsModal &&
                                                <IconWrapperMenu 
                                                    onClick={hadlePalletDetailsByOrder}
                                                >
                                                    <PackageIcon />
                                                </IconWrapperMenu>
                                            }
                                            <IconWrapperMenu
                                                onClick={handleOpenPalletLogfunc}
                                            >
                                                <LogIcon />
                                            </IconWrapperMenu>

                                        </WrapperMenu>
                                        </DropdownByIcon> 
                                        : Math.round(ProductsWithSupplyPacks / Products * 100) + "%"
                                    }
                                    problem={checkForResons}
                                />
                               
                            </QtyBoxWrapper>
                            <HeadContentElement>
                                
                                <HeadContentElement $date>
                                    {Packs}
                                    <IconWrapper>
                                        <PackageIcon />
                                    </IconWrapper>
                                    {currentDate}
                                    <CalendatDay />
                                </HeadContentElement>
                                {OrderID}
                                <IconWrapper>
                                    {showAcpaca}
                                </IconWrapper>
                                {/* <UserIcon /> */}
                            </HeadContentElement>
                            <HeadContentElement $primal >
                                {Customer_Name?.trim()}
                                <UserIcon />
                            </HeadContentElement>
                            <HeadContentElement  >
                                {
                                    workersList && workersList[WorkerID] ?
                                        <WorkerNameWrapper
                                            $clickable={!!handleOpenWorkerHistoryModal}
                                            onClick={handleOpenWorkerHistory}
                                        >
                                            <p style={{ color: 'tomato' }}>{workersList[WorkerID]}</p>
                                            <p style={{ color: 'tomato' }}><UserIcon /></p>
                                        </WorkerNameWrapper>
                                        : ''
                                }
                                {
                                    Status === 7 && item && !openEditRemarkLikut &&
                                    <SelectWorkerButton onClick={handleOpenSelectWorker}>
                                        <UserIcon />

                                    </SelectWorkerButton>
                                }
                                {
                                     item && openEditRemarkLikut &&
                                    <SelectWorkerButton onClick={handleOpenRemark}>
                                        <EditIcon />

                                    </SelectWorkerButton>
                                }
                                
                                <KwucaBlock $primal={GroupID !== 6}>
                                    {GroupDesc?.trim()}
                                </KwucaBlock>
                                {
                                    Delivery_Code === 1 ?
                                        <SunIcon /> :
                                        <MoonIcon />
                                }
                            </HeadContentElement>
                        </HeadContentWrapper>
                        <DetailesBody $isActive={showDetailes && checkForResons}>
                            <TitlesList 
                                list={detailes}
                                uniqueKey={'RecID'}
                                queryRender={detailesRenderQuery}
                                Element={DetailesItem}
                                additionalData={{
                                    isWeightCalculation: isWeightCalculation,
                                    selectIconForPalletType: selectIconForPalletType,
                                    selectProductForRemark: selectProductForRemark
                                }}
                            />
                        </DetailesBody>
                    </MainItemWrapper>
    )
}

export default React.memo(OrderGetheringItemWithDetailes)



const WrapperMenu = styled.div`
    padding: 0.1em;
    display: flex;
    gap: 0.5em;
`
const WorkerNameWrapper = styled.div`
    display: flex;
    gap: 0.5em;
    cursor: ${props => props.$clickable ? 'pointer' : 'inherit'};
`
const IconWrapperMenu = styled.div`
    width: 2em;
    height: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
    border-radius: 50%;
    background-color: #fff;
    color: ${props => props.$isPrimal ? 'tomato' : '#297F76'} ;
    
    cursor: pointer;
    
`